import Skeleton from 'components/3catinfo/Skeleton/Skeleton';
import styles from './destacatMedia.module.scss';

const DestacatMediaSkeleton = (props) => {
    return (
        <div>
            <section className={styles.cos}>
                <Skeleton titol className={styles.titol} num={1} />
                <div className={`${styles.imatgeWrapper} ${styles.imatgeSkeleton}`}>
                    <Skeleton imatge />
                </div>
            </section>
        </div>
    );
};

export default DestacatMediaSkeleton;
